// Phase 5 — first Angular Material component. Native replacement for the AngularJS
// Add Role modal (sudo/access/AddRoleController.js + add-role.html, both DELETED).
//
// Opened by RoleListComponent.add() via Material's MatDialog (was the upgraded $uibModal).
// The `type` (USER / DOCFLOW) is passed in through MAT_DIALOG_DATA; on a successful create
// we close with `true` so the caller knows to reload the list. Resolve/guard semantics mirror
// the old controller: both fields required, create then close-on-success.
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AccessService } from './access.service';

export interface AddRoleData {
    type: string;
}

@Component({
    selector: 'add-role',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
    ],
    templateUrl: './add-role.component.html',
    styles: ['.full-width { width: 100%; }'],
})
export class AddRoleComponent {
    private fb = inject(FormBuilder);
    private access = inject(AccessService);
    private dialogRef = inject(MatDialogRef<AddRoleComponent>);
    private data = inject<AddRoleData>(MAT_DIALOG_DATA);

    // Both fields required — preserves the old controller's `name.length && description.length` guard.
    form = this.fb.nonNullable.group({
        name: ['', Validators.required],
        description: ['', Validators.required],
    });

    create(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }
        const { name, description } = this.form.getRawValue();
        this.access.createRole({ name, description, type: this.data.type }).then((created) => {
            if (created) {
                this.dialogRef.close(true);
            }
        });
    }

    close(): void {
        this.dialogRef.close();
    }
}
